<mat-dialog-content>
    <section class="vacation-approvals-dialog-wrapper">
        <h2 class="cmn-popup-title">{{status ? 'Approval':'Rejection'}} Note</h2>
        <button class="cmn-close" mat-dialog-close></button>
        <form [formGroup]="applyApprovalForm">
        <div>
            <div class="vacation-form-wrapper">
                <div class="form-wrapper">
                    <label for="">Notes</label>
                    <mat-form-field>
                        <textarea matInput placeholder="{{status ? 'Approval':'Rejection'}} Note"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="btn-wrapper">
            <button type="submit" class="cmn-popup-btn" (click)="handleClick()">
                {{ status ? 'Approve' : 'Reject' }}
              </button>
              
          </div>
        </form>
    </section>
</mat-dialog-content>